module.exports = __webpack_public_path__ + "static/media/aleman.6eea1146.png";